<template>
  <div class="vh-100 d-flex align-items-center bg-dark">
    <div class="container-fluid" id="login_page">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-xl-4 my-5">
          <div class="align-items-center flex-column d-flex mb-5">
            <img
              src="@/assets/img/logo_3.svg"
              alt="Diag Backoffice"
              width="200"
            />
            <span class="badge bg-light fw-bold text-center mt-4">
              {{ $envString }}
            </span>
          </div>

          <form>
            <TextInput
              label="Email"
              :model="$v.form.email"
              type="email"
              placeholder="nome@email.com"
              labelClass="text-white"
            />
            <PasswordInput
              label="Senha"
              :model="$v.form.password"
              placeholder="Informe sua senha"
              labelClass="text-white"
            />

            <p class="text-danger text-center">{{ errorMessage }}</p>

            <FormButton
              label="Entrar"
              :loading="submitting"
              :disabled="$v.$invalid"
              class="btn w-100 btn-primary mb-3"
              @onClick="login"
            />

            <p class="text-center">
              <small class="text-light text-center">
                Esqueceu a senha?
                <router-link tag="a" :to="$paths.forgot_password">
                  Cadastre um nova</router-link
                >.
              </small>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginController from "./LoginController";
export default LoginController;
</script>
<style>
#login_page .bg-cover {
  background-image: url(../../assets/img/login_background.png);
}
</style>
